import { render, staticRenderFns } from "./AddZjAuth.vue?vue&type=template&id=36c06246&scoped=true"
import script from "./AddZjAuth.vue?vue&type=script&lang=js"
export * from "./AddZjAuth.vue?vue&type=script&lang=js"
import style0 from "./AddZjAuth.vue?vue&type=style&index=0&id=36c06246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c06246",
  null
  
)

export default component.exports